import { render, staticRenderFns } from "./UserProfileFormDialog.vue?vue&type=template&id=350c1a84&scoped=true&"
import script from "./UserProfileFormDialog.vue?vue&type=script&lang=js&"
export * from "./UserProfileFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileFormDialog.vue?vue&type=style&index=0&id=350c1a84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c1a84",
  null
  
)

export default component.exports